// extracted by mini-css-extract-plugin
module.exports = {"album__page":"style_album__page__HMTs8","album__container":"style_album__container__1ocb2","album__info":"style_album__info__1fnQy","track__list":"style_track__list__JgJUt"};